import {showSubmitDialog} from '@/land24';
import Tooltip from "bootstrap/js/dist/tooltip";
import {SystemConstants} from "@/models/system.models";

export const CONSTANTS: SystemConstants = {
    "METHAN_HS" : window.systemConstants.METHAN_HS,
    "METHAN_HI" : window.systemConstants.METHAN_HI,
    "HI_HS"     : window.systemConstants.HI_HS,
    "MJ_PER_KWH": window.systemConstants.MJ_PER_KWH,
    "BIOGAS_CH4": window.systemConstants.BIOGAS_CH4
}

window.addEventListener('load', () => {
    const editSelectors = document.querySelectorAll('.disableAccordion');
    editSelectors.forEach((editSelector) => {
        editSelector.addEventListener('mouseenter', () => {
            let accordionButton = editSelector.closest('.accordion-button');
            if (!accordionButton)
                accordionButton = editSelector.closest('[data-bs-toggle][aria-expanded]');
            if (accordionButton)
                accordionButton.setAttribute('data-bs-toggle', '');
        });
        editSelector.addEventListener('mouseleave', () => {
            let accordionButton = editSelector.closest('.accordion-button');
            if (!accordionButton)
                accordionButton = editSelector.closest('[data-bs-toggle][aria-expanded]');
            if (accordionButton)
                accordionButton.setAttribute('data-bs-toggle', 'collapse');
        });
    });

    const tooltips: Tooltip[] = [];
    const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    for (const el of tooltipElements as NodeListOf<HTMLElement>) {
        let tooltip = new Tooltip(el)

        if (el.dataset.appHighlight) {
            el.addEventListener('shown.bs.tooltip', () => {
                highlightElement(el.dataset.appHighlight ?? '')
            })
            el.addEventListener('hidden.bs.tooltip', () => {
                highlightElement(el.dataset.appHighlight ?? '', true)
            })
        }
        tooltips.push(tooltip);
    }

    const infoTooltipsSwitch = document.getElementById("app-settings-info-tooltips");
    if (tooltipElements.length <= 0) {
        infoTooltipsSwitch?.parentElement?.classList.add('d-none')
    } else {
        infoTooltipsSwitch?.parentElement?.classList.remove('d-none')
    }
    infoTooltipsSwitch?.addEventListener('change', (event) => {
        if ((event.target as HTMLInputElement)?.checked) {
            document.getElementById("main-container")?.classList.remove("hide-tooltips")
        } else {
            document.getElementById("main-container")?.classList.add("hide-tooltips")
        }
    })

    const userTypeSelectButtons = document.querySelectorAll('.userTypeSelect');
    userTypeSelectButtons.forEach((element) => {
        element.addEventListener('click', function () {
            let targetFrame = element.closest('.accordion-item') as HTMLElement;
            let searchBox = targetFrame.querySelectorAll('.userSearch ')[0] as HTMLElement;
            let searchLabel = targetFrame.querySelectorAll('label')[0] as HTMLLabelElement;
            let rows = targetFrame.querySelectorAll('.user-row') as NodeListOf<HTMLElement>;
            let activeUsers = 0;
            let inactiveUsers = 0;
            rows.forEach(row => {
                if (row.classList.contains('text-danger')) {
                    inactiveUsers++;
                } else {
                    activeUsers++;
                }
            })

            searchLabel.innerHTML = (inactiveUsers + activeUsers) + ' Benutzer (<span class="text-primary" title="aktive Benutzer">' + activeUsers + '</span> / <span class="text-danger" title="inaktive Benutzer">' + inactiveUsers + '</span>) Filter:';
            searchBox.focus();
        });
    });

    const userSearch = document.querySelectorAll('.userSearch') as NodeListOf<HTMLInputElement>;
    userSearch.forEach((element) => {
        if (element.dataset.targetFrame) {
            let targetFrame = document.getElementById(element.dataset.targetFrame) as HTMLElement;
            let rows = targetFrame.querySelectorAll('.row.user-row') as NodeListOf<HTMLElement>;
            element.addEventListener("keyup", function () {
                rows.forEach((row) => {
                    row.classList.add('d-none');
                    let searchFields = row.querySelectorAll('.searchField');
                    searchFields.forEach((name) => {
                        let searchField = name.innerHTML.toLocaleLowerCase();
                        let searchString = element.value.toLocaleLowerCase();
                        if (searchField.indexOf(searchString) > -1) {
                            row.classList.remove('d-none');
                        }
                    });
                });
            });
        }
    });
});

(window as any).showCompanyFields = showCompanyFields
export function showCompanyFields(element) {
    let type = element.options[element.selectedIndex].value;
    let companyData = document.getElementById('companyDataRegistration') as HTMLElement;
    let companyDataElements = companyData.querySelectorAll("select, input") as NodeListOf<HTMLInputElement | HTMLSelectElement>;
    const companyCategoryWrapper = document.getElementById('companyCategoryWrapper') as HTMLElement;
    const sureCertificateWrapper = document.getElementById('sureWrapper') as HTMLElement;
    const REDcertCertificateWrapper = document.getElementById('REDcertWrapper') as HTMLElement;


    if (['ROLE_BIO_PLANT', 'ROLE_TRADER'].includes(type)) {
        // companyDataElements.forEach(function(elem){ elem.setAttribute('required', 'required');});
        companyData.classList.remove('d-none');
        companyCategoryWrapper.classList.add('d-none');
        sureCertificateWrapper.classList.add('d-none');
        if (['ROLE_BIO_PLANT'].includes(type)) {
            companyCategoryWrapper.classList.remove('d-none');
        }
        if (['ROLE_TRADER'].includes(type)) {
            REDcertCertificateWrapper.classList.add('d-none');
            sureCertificateWrapper.classList.remove('d-none');
        }
        prefillCompanyFields();
    } else {
        companyDataElements.forEach(function (elem) {
            elem.removeAttribute('required');
        });
        if (companyData) {
            (companyData.querySelector('#user_firma_firma_art') as HTMLInputElement).value = ' ';
            (companyData.querySelector('#user_firma_firma_name') as HTMLInputElement).value = ' ';
            (companyData.querySelector('#user_firma_firma_strasse')  as HTMLInputElement).value = ' ';
            (companyData.querySelector('#user_firma_firma_plz') as HTMLInputElement).value = ' ';
            (companyData.querySelector('#user_firma_firma_ort') as HTMLInputElement).value = ' ';
            companyData.classList.add('d-none');
        }
    }
    if (element.value) {
        element.classList.remove('border-danger');
        element.classList.add('border-primary');
    } else {
        element.classList.add('border-danger');
        element.classList.remove('border-primary');
    }
}

(window as any).prefillCompanyFields = prefillCompanyFields
export function prefillCompanyFields() {
    let userData = document.getElementById('user_firma_user') as HTMLElement;
    let companyData = document.getElementById('companyDataRegistration') as HTMLElement;
    let input = userData.querySelector('#user_firma_user_roles') as HTMLInputElement
    if (['ROLE_BIO_PLANT', 'ROLE_TRADER'].includes(input.value)) {
        (companyData.querySelector('#user_firma_firma_art') as HTMLInputElement).value = input.value.replace('ROLE_', '');
    }
    // @ts-expect-error
    companyData.querySelector('#user_firma_firma_strasse').value = userData.querySelector('#user_firma_user_strasse').value;
    // @ts-expect-error
    companyData.querySelector('#user_firma_firma_plz').value = userData.querySelector('#user_firma_user_plz').value;
    // @ts-expect-error
    companyData.querySelector('#user_firma_firma_ort').value = userData.querySelector('#user_firma_user_ort').value;
}

(window as any).activateCompany = activateCompany
export function activateCompany(element, companyId) {
    let params = {'companyId': companyId}

    let buttons = {
        'aktivieren': {
            handler: (elem, modal) => {
                fetch("/verwaltung/firma/aktivieren", {
                    method: "POST",
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify(params)
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success === true) {
                            let baseElem = document.querySelector('#company' + companyId) as HTMLElement;
                            elem.remove();
                            baseElem.classList.remove('text-muted');
                        }
                    });
                modal.hide();
            },
            class: ["btn", "btn-primary"],
            type: 'dismiss'
        },
        'verwerfen': {
            class: ["btn", "btn-secondary"],
            type: 'dismiss'
        }
    };

    showSubmitDialog(element, 'Weitere Firma aktivieren', 'Durch das aktivieren einer weiteren Firma fallen Kosten für Benutzer an.', buttons);
    return false;
}

(window as any).lockCompany = lockCompany
export function lockCompany(element, companyId) {
    let params = {'companyId': companyId}
    let name = element.innerText;
    const classes = [...element.classList].filter((value) => {
        return !["mb-1"].includes(value);
    });

    if (name === '') {
        name = element.firstElementChild.title;
    }

    let buttons = {};
    buttons[name] = {
        handler: (elem, modal) => {
            fetch("/verwaltung/firma/sperren", {
                method: "POST",
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(params)
            })
                .then(response => response.json())
                .then(data => {
                    let baseElem = document.querySelector('#company' + companyId) as HTMLElement
                    let icon = elem.querySelector('i') as HTMLElement;
                    let text = elem.querySelector('span') as HTMLSpanElement;
                    if (data.success === true) {
                        if (data.locked === true) {
                            elem.classList.remove('btn-danger');
                            elem.classList.add('btn-primary');
                            icon.classList.remove('bi-lock');
                            icon.classList.add('bi-unlock');
                            icon.title = 'Firma freigeben';
                            text.innerHTML = 'freigeben';
                            baseElem.classList.add('text-danger');

                        } else {
                            elem.classList.remove('btn-primary');
                            elem.classList.add('btn-danger');
                            icon.classList.remove('bi-unlock');
                            icon.classList.add('bi-lock');
                            icon.title = 'Firma sperren';
                            text.innerHTML = 'sperren';
                            baseElem.classList.remove('text-danger');
                        }
                    }
                });
            modal.hide();
        },

        class: classes,
    };

    buttons["verwerfen"] = {
        class: ["btn", "btn-secondary"],
        type: 'dismiss'
    }
    if (name === 'freigeben') {
        showSubmitDialog(element, 'Firma freigeben', 'Wollen Sie die gewählte Firma wirklich freigeben?<br><br><span class="text-danger">Das Freigeben von mehr als 2 Firmen ist für den Benutzer mit Mehrkosten verbunden!</span>', buttons);
    } else {
        showSubmitDialog(element, 'Firma sperren', 'Wollen Sie die gewählte Firma wirklich sperren?', buttons);
    }
    return false;
}

class Counter__ {
    input: HTMLInputElement
    form: HTMLFormElement
    submit: HTMLButtonElement
    inputFrame: HTMLElement
    inputWrapper: HTMLElement
    newCounter: HTMLElement
    newCounterInput: HTMLInputElement
    message: HTMLElement
    minReading: number


    constructor(inputElement) {
        this.input = inputElement;
        this.form = this.input.form as HTMLFormElement;
        this.submit = this.form.querySelector('#fackel_laufzeitdaten_speichern') as HTMLButtonElement;
        this.inputFrame = this.input.closest('.row') as HTMLElement;
        this.inputWrapper = this.input.closest('div') as HTMLElement;
        this.newCounter = this.inputFrame.querySelector('.newCounter') as HTMLElement;
        this.newCounterInput = this.newCounter.querySelector('input') as HTMLInputElement;
        this.message = this.inputFrame.querySelector('.messageRow') as HTMLElement;
        this.minReading = 0;

        this.input.dataset.valid = 'true';
        if (!this.input.classList.contains('counterInput'))
            this.input.classList.add('counterInput');

        if (!this.message) {
            this.createMessage();
        }
    }

    // fetch(){
    //     this.fetched = true;
    //     return this;
    // }

    checkReading() {
        this.toggleMessage(false);

        if (parseInt(this.input.value) <= this.minReading) {
            this.input.dataset.valid = 'false';
            if (this.newCounterInput) {
                this.newCounterInput.addEventListener('click', () => ((counter) => {
                    let checkedBoxes = counter.form.querySelectorAll('.form-check-input') as NodeListOf<HTMLInputElement>;
                    checkedBoxes.forEach(function (cb) {
                        let row = cb.closest('.row') as HTMLElement;
                        let counterInput;
                        if (row) {
                            counterInput = row.querySelector('.counterInput') as HTMLElement;
                        }

                        if (counterInput) {
                            counterInput.dataset.valid = cb.checked;
                        }
                        counter.checkValid();
                    });
                })(this));
            }
            this.toggleMessage(true);
        } else {
            this.input.dataset.valid = 'true';
        }
        this.checkValid();
    }

    toggleMessage(show) {
        if (show) {
            this.message.classList.remove('d-none');
            this.inputWrapper.classList.remove('col-8');
            this.inputWrapper.classList.add('col-5');
            this.newCounter.classList.remove('d-none');
        } else {
            this.message.classList.add('d-none');
            this.inputWrapper.classList.remove('col-5');
            this.inputWrapper.classList.add('col-8');
            this.newCounter.classList.add('d-none');
        }
    }

    checkValid() {
        let counterInputs = this.form.querySelectorAll('.counterInput') as NodeListOf<HTMLElement>;
        let valid = true;
        counterInputs.forEach(function (input) {
            if (input.dataset.valid === 'false') {
                valid = false;
            }
        });

        this.submit.setAttribute('disabled', 'disabled');
        if (valid) {
            this.submit.removeAttribute('disabled');
            this.toggleMessage(false);
        }
    }

    createMessage() {
        let messageRow = document.createElement('div');
        messageRow.classList.add('row', 'messageRow');
        let messageCol = document.createElement('div');
        messageCol.classList.add('col', 'message', 'text-danger', 'd-none');
        messageCol.innerHTML = 'Bitte geben Sie einen Zählerstand größer <span class="fw-bold">' + this.minReading + "</span> ein!<br/>Sollten Sie einen neuen Zähler installiert haben aktivieren Sie bitte die Checkbox [neuer Zähler].";
        messageRow.append(messageCol)
        this.inputFrame.append(messageRow);
        this.message = messageCol;
    }
}

export function createTextElement(type: string, text: string, classes: string[] = [], styles: Record<string, string> = {}) {
    let element = document.createElement(type);
    classes.forEach((c) => {
        element.classList.add(c);
    });
    for (const [k, v] of Object.entries(styles)) {
        element.style[k] = v;
    }
    element.innerHTML = text


    return element;
}

(window as any).highlightElement = highlightElement
export function highlightElement(className: string, remove = false) {
    let elements = document.getElementsByClassName(className);
    for (let element of elements) {
        if (remove) {
            element.classList.remove('app-highlighted');
        } else {
            element.classList.add('app-highlighted');
        }
    }
}